import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "../ui/Tooltip";

interface NavTooltipProps {
    name: string;
    icon: any;
}

export default function NavTooltip({ name, icon }: NavTooltipProps) {
    return (
        <TooltipProvider>
            <Tooltip delayDuration={100}>
                <TooltipTrigger>{icon}</TooltipTrigger>
                <TooltipContent side="right" sideOffset={8}>
                    {name}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
